import { render, staticRenderFns } from "./DialogRemoveNote.vue?vue&type=template&id=14824d2a"
import script from "./DialogRemoveNote.vue?vue&type=script&lang=js"
export * from "./DialogRemoveNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports